import { Component } from '@angular/core';

import { BlockPreviewSettingsService } from './block-preview-settings.service';

/** The Preview toggle (#263) for an editor's action bar: shows or hides the panel, remembered in this browser. */
@Component({
  selector: 'app-block-preview-toggle',
  template: `<span [pTooltip]="settings.available ? '' : notSetUp" tooltipPosition="top">
    <button
      pButton
      type="button"
      class="p-button-sm block-preview-toggle"
      [class.p-button-outlined]="!pressed"
      icon="pi pi-eye"
      label="Preview"
      [attr.aria-pressed]="pressed"
      [disabled]="!settings.available"
      (click)="settings.set(!settings.on)"
    ></button>
  </span>`,
})
export class BlockPreviewToggleComponent {
  readonly notSetUp = "Preview isn't set up on this server.";

  constructor(public settings: BlockPreviewSettingsService) {}

  get pressed(): boolean {
    return this.settings.shown;
  }
}
